var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('hr',{staticClass:"WPDivider",class:{ WPDivider_primary: _vm.primary !== false },attrs:{"role":"separator","aria-orientation":"horizontal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }